import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { SessionService } from '../session/session.service';
import { ApiDataService } from './api-data.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../session/session.service";
var DataService = /** @class */ (function (_super) {
    tslib_1.__extends(DataService, _super);
    function DataService(httpClient, sessionService) {
        var _this = _super.call(this) || this;
        _this.httpClient = httpClient;
        _this.sessionService = sessionService;
        _this.companyUserListChanged = false;
        _this.employmentTemplatesChanged = false;
        _this.sessionService.isAlive.subscribe(function () {
            if (!_this.sessionService.checkIsAliveError) {
                _this.sessionService.checkIsAliveActive = true;
                _super.prototype.Auth_IsSessionAlive.call(_this).subscribe(function () {
                    _this.sessionService.checkIsAliveActive = false;
                }, function (err) {
                    /* Ignore errors from IsSessionAlive call */
                    if (err && err.status !== 0 && err.status !== -1) {
                        _this.sessionService.checkIsAliveActive = false;
                        _this.sessionService.checkIsAliveError = true;
                    }
                });
            }
        });
        return _this;
    }
    Object.defineProperty(DataService.prototype, "needToReloadCompanyUsers", {
        get: function () {
            return !this.companyUsers || this.companyUsers.length === 0 || this.companyUserListChanged;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataService.prototype, "needToReloadEmployeeTemplate", {
        get: function () {
            return !this.employmentTemplates || this.employmentTemplatesChanged;
        },
        enumerable: true,
        configurable: true
    });
    DataService.prototype.httpGet = function (path, options) {
        return this.httpClient.get(path, options);
    };
    DataService.prototype.httpDelete = function (path, options) {
        return this.httpClient.delete(path, options);
    };
    DataService.prototype.httpPost = function (path, object, options) {
        return this.httpClient.post(path, object, { headers: { 'Content-Type': 'application/json' } });
    };
    DataService.prototype.httpPut = function (path, object, options) {
        return this.httpClient.put(path, object, { headers: { 'Content-Type': 'application/json' } });
    };
    DataService.prototype.httpPatch = function (path, object, options) {
        return this.httpClient.patch(path, object, { headers: { 'Content-Type': 'application/json' } });
    };
    DataService.prototype.httpDownload = function (path, options) {
        return this.httpClient
            .get(path, { observe: 'response', responseType: 'arraybuffer', headers: { 'Content-Type': 'application/json' } })
            .pipe(map(function (result) {
            return result;
        }));
    };
    DataService.prototype.httpPostDownload = function (path, object, options) {
        return this.httpClient
            .post(path, object, {
            observe: 'response',
            responseType: 'arraybuffer',
            headers: { 'Content-Type': 'application/json' }
        })
            .pipe(map(function (result) {
            return result;
        }));
    };
    DataService.prototype.httpPostAttachment = function (path, data) {
        return this.httpClient.post(path, data).pipe(map(function (result) {
            return result;
        }));
    };
    DataService.prototype.httpPostAttachmentAndDownload = function (path, data, options) {
        return this.httpClient.post(path, data, { responseType: 'arraybuffer' }).pipe(map(function (result) {
            return result;
        }));
    };
    DataService.prototype.roundDecimal = function (value, decimals) {
        if (value) {
            return parseFloat(value.toFixed(decimals));
        }
        return undefined;
    };
    DataService.prototype.Users_GetUserImage = function (userId) {
        var path = this.baseUrl + '/api/users/{userId}/image';
        if (userId) {
            path = this.baseUrl + '/api/users/{userId}/image';
            path = path.replace('{userId}', userId.toString());
            return this.httpGet(path);
        }
        else {
            return _super.prototype.Users_GetCurrentUserImage.call(this);
        }
    };
    DataService.prototype.SalaryStatements_PostPdfFromClient_Encoded = function (salaryStatement) {
        var path = this.baseUrl + 'api/salarystatements/pdf/fromclient/encoded';
        return this.httpPost(path, salaryStatement);
    };
    DataService.prototype.Companies_UploadCompanyLogo = function (formData) {
        var path = this.baseUrl + '/api/companies/current/logo';
        return this.httpPostAttachment(path, formData);
    };
    DataService.prototype.Users_CurrentImage = function (formData) {
        var path = this.baseUrl + '/api/users/current/image';
        return this.httpPostAttachment(path, formData);
    };
    DataService.prototype.User_UploadEmployeeImage = function (data, userId) {
        var path = this.baseUrl + '/api/users/{userId}/image';
        path = path.replace('{userId}', userId.toString());
        return this.httpPostAttachment(path, data);
    };
    DataService.prototype.CompanyUsers_UpdateCompanyUser = function (companyUser) {
        var _this = this;
        return _super.prototype.CompanyUsers_UpdateCompanyUser.call(this, companyUser).pipe(tap(function () { return (_this.companyUserListChanged = true); }));
    };
    DataService.prototype.CompanyUsers_AddUserToCompany = function (request) {
        var _this = this;
        return _super.prototype.CompanyUsers_AddUserToCompany.call(this, request).pipe(tap(function () { return (_this.companyUserListChanged = true); }));
    };
    DataService.prototype.CompanyUsers_DeleteCompanyUser = function (companyUserId) {
        var _this = this;
        return _super.prototype.CompanyUsers_DeleteCompanyUser.call(this, companyUserId).pipe(tap(function () { return (_this.companyUserListChanged = true); }));
    };
    DataService.prototype.loadEmploymentTemplates_GetEmploymentTemplates = function () {
        var _this = this;
        return Observable.create(function (observer) {
            _super.prototype.EmploymentTemplates_GetEmploymentTemplates.call(_this).subscribe(function (data) {
                _this.employmentTemplatesChanged = false;
                _this.employmentTemplates = data;
                observer.next(data.slice());
            }, function (error) {
                throwError(error);
            });
        });
    };
    DataService.prototype.EmploymentTemplates_GetEmploymentTemplates = function (forceLoad) {
        var _this = this;
        if (forceLoad === void 0) { forceLoad = false; }
        if (forceLoad || this.needToReloadEmployeeTemplate) {
            this.employmentTemplates = []; //// block new request when waiting the response of the api
            return this.loadEmploymentTemplates_GetEmploymentTemplates();
        }
        return Observable.create(function (observer) {
            if (_this.employmentTemplates.length > 0) {
                observer.next(_this.employmentTemplates.slice());
            }
            else {
                //// wait the api CompanyUsers_GetCompanyUsers response
                setTimeout(function () {
                    observer.next(_this.employmentTemplates.slice());
                }, 4000);
            }
        });
    };
    DataService.prototype.EmploymentTemplates_UpdateEmploymentTemplate = function (template) {
        var _this = this;
        return Observable.create(function (observer) {
            _super.prototype.EmploymentTemplates_UpdateEmploymentTemplate.call(_this, template).subscribe(function (data) {
                _this.employmentTemplatesChanged = true;
                observer.next(data);
            }, function (error) {
                throwError(error);
            });
        });
    };
    DataService.prototype.EmploymentTemplates_CreateEmploymentTemplate = function (template) {
        var _this = this;
        return Observable.create(function (observer) {
            _super.prototype.EmploymentTemplates_CreateEmploymentTemplate.call(_this, template).subscribe(function (data) {
                _this.employmentTemplatesChanged = true;
                observer.next(data);
            }, function (error) {
                throwError(error);
            });
        });
    };
    DataService.prototype.EmploymentTemplates_DeleteEmploymentTemplate = function (templateId) {
        var _this = this;
        return Observable.create(function (observer) {
            _super.prototype.EmploymentTemplates_DeleteEmploymentTemplate.call(_this, templateId).subscribe(function (result) {
                _this.employmentTemplatesChanged = true;
                observer.next(result);
            }, function (error) {
                throwError(error);
            });
        });
    };
    DataService.prototype.EmploymentTemplates_CreateTemplateFromEmployment = function (request) {
        var _this = this;
        return Observable.create(function (observer) {
            _super.prototype.EmploymentTemplates_CreateTemplateFromEmployment.call(_this, request).subscribe(function (result) {
                _this.employmentTemplatesChanged = true;
                observer.next(result);
            }, function (error) {
                throwError(error);
            });
        });
    };
    DataService.prototype.SalaryBatches_GetSalaryPeriods = function (cycleId) {
        var _this = this;
        return Observable.create(function (observer) {
            if (_this.salaryPeriods && _this.cycleId === cycleId) {
                observer.next(_this.salaryPeriods.slice());
            }
            else {
                _super.prototype.SalaryBatches_GetSalaryPeriods.call(_this, cycleId).subscribe(function (data) {
                    var currentYeader = new Date().getFullYear();
                    data = data.filter(function (item) {
                        return (new Date(item.EndDate).getFullYear() >= currentYeader - 1 &&
                            new Date(item.EndDate).getFullYear() <= currentYeader + 1);
                    });
                    _this.salaryPeriods = data;
                    _this.cycleId = cycleId;
                    observer.next(data.slice());
                }, function (error) {
                    throwError(error);
                });
            }
        });
    };
    DataService.prototype.CompanyUsers_GetCurrentTaxInfo = function (userEmploymentId) {
        return _super.prototype.Employments_GetCurrentTaxInfo.call(this, userEmploymentId);
    };
    DataService.prototype.EmploymentTemplates_GetEmploymentTemplate = function (templateId) {
        var _this = this;
        return Observable.create(function (observer) {
            _super.prototype.EmploymentTemplates_GetEmploymentTemplate.call(_this, templateId).subscribe(function (template) {
                if (template) {
                    if (template.VacationTypeId === 0) {
                        template.VacationTypeId = undefined;
                    }
                    if (template.PensionProviderId === 0) {
                        template.PensionProviderId = undefined;
                    }
                    if (template.PensionBaseCalculationMethodId === 0) {
                        template.PensionBaseCalculationMethodId = undefined;
                    }
                    if (template.Pension2ProviderId === 0) {
                        template.Pension2ProviderId = undefined;
                    }
                    if (template.Pension2BaseCalculationMethodId === 0) {
                        template.Pension2BaseCalculationMethodId = undefined;
                    }
                    if (template.SalaryCycleId === 0) {
                        template.SalaryCycleId = undefined;
                    }
                    if (template.VacationProviderId === 0) {
                        template.VacationProviderId = undefined;
                    }
                    if (template.VacationSupplementPayoutMonth === 0) {
                        template.VacationSupplementPayoutMonth = undefined;
                    }
                }
                observer.next(template);
            }, function (error) {
                throwError(error);
            });
        });
    };
    DataService.prototype.SalaryRecords_GetSalaryRecordsByEmployment = function (userEmploymentId) {
        var _this = this;
        return Observable.create(function (observer) {
            _super.prototype.SalaryRecords_GetSalaryRecordsByEmployment.call(_this, userEmploymentId).subscribe(function (salaryRecords) {
                if (salaryRecords) {
                    salaryRecords.forEach(function (salaryRecord) {
                        if (salaryRecord.Units) {
                            salaryRecord.Units = _this.roundDecimal(salaryRecord.Units, 2);
                        }
                        if (salaryRecord.AmountPerUnit) {
                            salaryRecord.AmountPerUnit = _this.roundDecimal(salaryRecord.AmountPerUnit, 2);
                        }
                        if (salaryRecord.Amount) {
                            salaryRecord.Amount = _this.roundDecimal(salaryRecord.Amount, 2);
                        }
                    });
                }
                observer.next(salaryRecords);
            }, function (error) {
                throwError(error);
            });
        });
    };
    DataService.prototype.Users_SetLanguageContext = function (languageId) {
        var path = this.baseUrl + '/api/users/current/language/{languageId}';
        path = path.replace('{languageId}', languageId.toString());
        return this.httpPut(path, undefined);
    };
    DataService.prototype.Miscellaneous_FailNotFound = function () {
        var path = this.baseUrl + '/api/fail/notfound';
        return this.httpGet(path);
    };
    DataService.prototype.CompanyDataImport_PostEmployeeFilledTemplate = function (data) {
        var path = this.baseUrl + '/api/import/employees/execute';
        return this.httpPostAttachment(path, data);
    };
    DataService.prototype.CompanyDataImport_PostEmployeeFilledTemplateWithOptions = function (data, options) {
        var path = this.baseUrl + '/api/import/employees/execute/options/{options}';
        path = path.replace('{options}', options.toString());
        return this.httpPostAttachment(path, data);
    };
    DataService.prototype.EmployeeDataImport_PerformBalancesCorrection = function (data) {
        var path = this.baseUrl + '/api/import/balances/correction';
        return this.httpPostAttachment(path, data);
    };
    DataService.prototype.CompanyDataImport_PostBalancesFilledTemplate = function (data, options) {
        var path = this.baseUrl + '/api/import/balances/{options}';
        path = path.replace('{options}', options.toString());
        return this.httpPostAttachment(path, data);
    };
    DataService.prototype.SalaryStatements_GetHtml = function (salaryStatementId, outputType) {
        if (outputType === void 0) { outputType = 'html'; }
        return _super.prototype.SalaryStatements_GetHtml.call(this, salaryStatementId, outputType);
    };
    DataService.prototype.ImportMapping_GetExcelHeadersOfFile = function (fileData) {
        var path = this.baseUrl + '/api/import/headers';
        return this.httpPostAttachment(path, fileData);
    };
    DataService.prototype.ImportMapping_DanloenPdfToExcel = function (request) {
        var path = this.baseUrl + '/api/import/convert/danloenpdf';
        return this.httpPostAttachmentAndDownload(path, request);
    };
    DataService.prototype.CompanyDataImport_PlanDayToExcel = function (operation, data) {
        var path = this.baseUrl + '/api/import/convert/planday/excel/{operation}';
        path = path.replace('{operation}', operation.toString());
        return this.httpPostAttachmentAndDownload(path, data);
    };
    DataService.prototype.CompanyDataImport_DatFileAofToExcel = function (operation, data) {
        var path = this.baseUrl + 'api/import/aof/excel';
        return this.httpPostAttachmentAndDownload(path, data);
    };
    DataService.prototype.ImportMapping_DatFileToExcel = function (request) {
        var path = this.baseUrl + '/api/import/convert/epwin';
        return this.httpPostAttachmentAndDownload(path, request);
    };
    DataService.prototype.Import_PayrollDataImport = function (data, options) {
        var path = this.baseUrl + '/api/import/salaryrecords/{options}';
        path = path.replace('{options}', options.toString());
        return this.httpPostAttachment(path, data);
    };
    DataService.prototype.SalaryStatements_GetPdf = function (salaryStatementId) {
        var path = this.baseUrl + '/api/salarystatements/{salaryStatementId}/a4ppdf';
        path = path.replace('{salaryStatementId}', salaryStatementId.toString());
        return this.httpDownload(path);
    };
    DataService.prototype.SalaryStatements_GetPdfMergedBySalaryBatch = function (salaryBatchId) {
        var path = this.baseUrl + '/api/salarystatements/salarybatch/{salaryBatchId}/pdf/merged';
        path = path.replace('{salaryBatchId}', salaryBatchId.toString());
        return this.httpDownload(path);
    };
    DataService.prototype.Reports_GetPdfReport = function (request) {
        var path = this.baseUrl + '/api/reports/pdf';
        return this.httpPostDownload(path, request);
    };
    DataService.prototype.Reports_GetXlsxReportDownload = function (request) {
        var path = this.baseUrl + '/api/reports/xlsx';
        return this.httpPostDownload(path, request);
    };
    DataService.prototype.Reports_GetSeReportDownload = function (request) {
        var path = this.baseUrl + '/api/reports/si';
        return this.httpPostDownload(path, request);
    };
    DataService.prototype.Reports_GetCsvReportDownload = function (request) {
        var path = this.baseUrl + '/api/reports/csv';
        return this.httpPostDownload(path, request);
    };
    DataService.prototype.Reports_GetBankReportDownload = function (request) {
        var path = this.baseUrl + '/api/reports/bank';
        return this.httpPostDownload(path, request);
    };
    DataService.prototype.Reports_GetXMLDownload = function (request) {
        var path = this.baseUrl + '/api/reports/xml';
        return this.httpPostDownload(path, request);
    };
    DataService.prototype.Reports_GetReportDownloadWithOutput = function (outputFormat, request) {
        var path = this.baseUrl + '/api/reports/{outputFormat}';
        path = path.replace('{outputFormat}', outputFormat.toString());
        return this.httpPostDownload(path, request);
    };
    DataService.prototype.Reports_GetHtmlReportDownload = function (request) {
        var path = this.baseUrl + '/api/reports/html';
        return this.httpPost(path, request);
    };
    DataService.prototype.Download_ImportMapping_GetFilledImportTemplateWithParameters = function (mappingId, parameters) {
        var path = this.baseUrl + '/api/importmapping/{mappingId}/template/filled';
        path = path.replace('{mappingId}', mappingId.toString());
        return this.httpPostDownload(path, parameters);
    };
    DataService.prototype.Download_ImportMapping_GetImportTemplateWithParameters = function (mappingId, parameters) {
        var path = this.baseUrl + '/api/importmapping/{mappingId}/template';
        path = path.replace('{mappingId}', mappingId.toString());
        return this.httpPostDownload(path, parameters);
    };
    DataService.prototype.Download_ImportMapping_GetFilledImportTemplate = function (mappingId) {
        var path = this.baseUrl + '/api/importmapping/{mappingId}/template/filled';
        path = path.replace('{mappingId}', mappingId.toString());
        return this.httpDownload(path);
    };
    DataService.prototype.Download_ImportMapping_GetImportTemplate = function (mappingId) {
        var path = this.baseUrl + '/api/importmapping/{mappingId}/template';
        path = path.replace('{mappingId}', mappingId.toString());
        return this.httpDownload(path);
    };
    DataService.prototype.SalaryStatements_PrintHtmlPreview = function (outputType, statement) {
        var path = this.baseUrl + '/api/salarystatements/{outputType}/fromclient/DoPrint';
        path = path.replace('{outputType}', outputType.toString());
        return this.httpPost(path, statement);
    };
    DataService.prototype.Payslip_GetPrintHTML = function (downloadUrl) {
        var path = this.baseUrl + downloadUrl;
        return this.httpDownload(path);
    };
    DataService.prototype.Companies_UpdateCurrentPatch = function (company) {
        var path = this.baseUrl + '/api/companies/current';
        return this.httpPatch(path, company);
    };
    DataService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DataService_Factory() { return new DataService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.SessionService)); }, token: DataService, providedIn: "root" });
    return DataService;
}(ApiDataService));
export { DataService };
